// extracted by mini-css-extract-plugin
export var animationContainer = "_n2-0";
export var footer = "_n2-1";
export var gray = "_n2-2";
export var lineItem = "_n2-3";
export var lineItemImage = "_n2-4";
export var lineItemInfo = "_n2-5";
export var lineItemText = "_n2-6";
export var lineItems = "_n2-7";
export var modalContent = "_n2-8";
export var options = "_n2-9";
export var orderName = "_n2-a";
export var refundAmount = "_n2-b";